import { Button, Grid, Typography } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import GroupIcon from '@material-ui/icons/Group';
import React from 'react';
import { connect } from 'react-redux';

import { App, Tournament } from '@aps-management/primapp-common';

import { Screen } from '_components/core';
import apolloClient from '_utils/apolloClient';
import i18n from '_utils/i18n';

import Header from '../_Header';

/* */
class TournamentEnter extends React.Component {
  /* */
  constructor(props) {
    super(props);

    const {
      account,
      golf,
      match: { params },
    } = props;

    this.id = params.id;
    this.accountMatch = App.functions.match(account, golf) || { isMember: false, reference: 'UNKNOWN' };

    this.state = {
      // Screen
      error: null,
      loading: true,
      // Data
      myEntry: null,
      entryList: [],
      partners: [],
      tournament: null,
    };
  }

  /* */
  componentDidMount() {
    this.load();
  }

  /* */
  goToNext = () => this.props.history.push(`/tournament/${this.id}/entrants`);

  /* */
  goToMyTournaments = () => this.props.history.push('/mytournaments');

  /* */
  load() {
    const { id } = this;
    const {
      account: { ffg },
      golf,
    } = this.props;

    if (!id) {
      return this.setState({
        loading: false,
        error: 'errors.not_found',
      });
    }

    return Tournament.api
      .getTournament(apolloClient, { id, golfId: golf.id })
      .then((tournament) => {
        this.setState({ tournament });

        const { lifecycle } = tournament;
        const { status } = Tournament.functions.getRegistrationStatus(tournament);

        // Seulement si la compétition est en mode "inscription"
        if (status !== 1 && lifecycle === 'registration') {
          return Tournament.api.getEntryList(apolloClient, { id, golfId: golf.id });
        }

        return Promise.resolve({ entries: [] });
      })
      .then(({ entries }) => {
        this.setState({ entryList: entries });
        if (ffg.license) {
          const { entry, partners } = Tournament.functions.getEntryStatus(entries, ffg.license);
          this.setState({ entry, partners });
        }
      })
      .catch((e) => this.setState({ error: e.message }))
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  /* */
  renderEntry() {
    const { golf } = this.props;
    const { entry } = this.state;

    if (!entry) return null;

    return (
      <React.Fragment>
        <Typography variant='body1'>{i18n.getFromOpts('event_enter.already_in', golf.options)}</Typography>
        <br />
        <Button color='secondary' variant='outlined' onClick={this.goToMyTournaments}>
          {'Voir mes inscriptions'}
        </Button>
      </React.Fragment>
    );
  }

  /* */
  renderEntryList() {
    const { entryList, tournament } = this.state;

    if (!tournament.showEntryList || !entryList.length) return null;

    const entriesByTeam = entryList
      .filter((e) => e.teamNumber !== null)
      .reduce((acc, v) => {
        if (acc[v.teamNumber] === undefined) {
          acc[v.teamNumber] = [];
        }
        acc[v.teamNumber].push(v);

        return acc;
      }, {});
    const unassignedEntries = entryList.filter((e) => e.teamNumber === null);

    const columns = 3;
    const numberOfTeams = Object.keys(entriesByTeam).length;
    const teamsPerColumn = Math.ceil(numberOfTeams / columns);
    const numberOfUnassigned = unassignedEntries.length;
    const entriesPerColumn = Math.ceil(numberOfUnassigned / columns);

    return (
      <Box mt={3}>
        <Typography gutterBottom variant='body1'>
          {`Liste des inscrits (${entryList.length})`}
        </Typography>
        {numberOfTeams > 0 && (
          <Grid container>
            {[...Array(columns)].map((_, c) => (
              <Grid item xs={12} sm={6} md={4} key={c}>
                {Object.entries(entriesByTeam)
                  .slice(c * teamsPerColumn, (c + 1) * teamsPerColumn)
                  .map(([teamNumber, entries]) => (
                    <Box key={teamNumber} mb={2}>
                      <Typography gutterBottom variant='subtitle2' color='textSecondary'>
                        <GroupIcon fontSize='small' style={{ verticalAlign: 'middle', marginRight: 4 }} />
                        Équipe {teamNumber}
                      </Typography>
                      {entries.map((e, i) => (
                        <Typography key={i} variant='caption'>
                          {e.name}
                        </Typography>
                      ))}
                    </Box>
                  ))}
              </Grid>
            ))}
          </Grid>
        )}
        {numberOfUnassigned > 0 && (
          <>
            {numberOfTeams > 0 && (
              <Box pt={2} borderTop={1} borderColor='#ddd'>
                <Typography gutterBottom variant='subtitle2' color='textSecondary'>
                  <GroupIcon fontSize='small' style={{ verticalAlign: 'middle', marginRight: 4 }} />
                  Non assigné
                </Typography>
              </Box>
            )}
            <Grid container>
              {[...Array(columns)].map((_, c) => (
                <Grid item xs={12} sm={6} md={4} key={c}>
                  {unassignedEntries.slice(c * entriesPerColumn, (c + 1) * entriesPerColumn).map((e, key) => (
                    <Typography key={key} variant='caption'>
                      {e.name}
                    </Typography>
                  ))}
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Box>
    );
  }

  /* */
  renderEnterButton() {
    const { entry, tournament } = this.state;
    const {
      registration: { limit, counter, isMemberOnly },
    } = tournament;

    // Inscription ouverte + joueur non inscrit
    const isOpened = !entry && Tournament.functions.isOpened(tournament);
    if (!isOpened) return null;

    // Membre uniquement
    if (!this.accountMatch.isMember && isMemberOnly) return null;

    // Limite atteinte
    if (limit && counter >= limit) {
      return (
        <Button disabled fullWidth size='large' onClick={null} color='primary' variant='contained'>
          {'Complet'}
        </Button>
      );
    }

    return (
      <Button fullWidth size='large' color='secondary' variant='contained' onClick={this.goToNext}>
        {'Participer'}
      </Button>
    );
  }

  /* */
  render() {
    const { error, loading, tournament } = this.state;

    return (
      <Screen error={error} loading={loading} title="Compétitions - S'inscrire">
        {tournament && (
          <React.Fragment>
            <Header tournament={tournament} />
            {this.renderEntry()}
            {this.renderEnterButton()}
            {this.renderEntryList()}
          </React.Fragment>
        )}
      </Screen>
    );
  }
}

const mapStateToProps = ({ app }) => ({
  golf: app.golf,
  account: app.account,
});

export default connect(mapStateToProps)(TournamentEnter);
